module.exports = __webpack_public_path__ + "src/assets/img/pic (1).788a5283.jpg";